import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AddModeratorOutlined } from '@mui/icons-material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Checkbox, Tooltip, Typography, Stack } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

const AddSectionToTOSButton = ({
  questions,
  tosBatch,
  addQuestion,
  removeQuestion,
  updateCheckboxes,
  hide,
  prevRecipients,
  nrOfRecipients,
}) => {
  const [checked, setChecked] = useState(false);
  const [questionIds, setQuestionIds] = useState([]);

  const { t } = useTranslation('translation', { keyPrefix: 'gap_analysis' });

  const handleChange = event => {
    if (!questionIds || questionIds.length <= 0) return;
    setChecked(event.target.checked);
    // If already checked, remove all questions on click
    questionIds.map(id => {
      event.target.checked ? addQuestion(id) : removeQuestion(id);
    });
    updateCheckboxes();
  };

  useEffect(() => {
    if (questions) {
      setQuestionIds(questions.map(question => question.id));
    }
    setChecked(false);
  }, [questions]);

  useEffect(() => {
    if (!questionIds || questionIds.length <= 0) return;
    // To check button if ALL questions in section are in batch:
    // ALL: let matchingQuestionsInBatch = 0;

    // To check button if ONE question in section is in batch
    let matchingQuestionInBatch = false;
    tosBatch.map(question => {
      questionIds.map(id => {
        if (question === id) {
          // ALL: matchingQuestionsInBatch++;
          matchingQuestionInBatch = true;
        }
      });
    });
    // ALL: matchingQuestionsInBatch >= questionIds.length ? setChecked(true) : setChecked(false);
    setChecked(matchingQuestionInBatch);
  }, [tosBatch, questionIds]);

  return (
    <Tooltip
      title={
        <Stack>
          {prevRecipients?.map && nrOfRecipients > 0 ? (
            <>
              <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
                {checked ? t('tos_remove_all_tooltip') : t('tos_add_all_tooltip')}
              </Typography>
              <Typography variant='caption'>
                {t('tos_previously_assigned_section_1')}
                {nrOfRecipients}
                {t('tos_previously_assigned_section_2')}
              </Typography>
              {prevRecipients.map((email, index) => (
                <Typography variant='caption' key={index}>
                  {email}
                </Typography>
              ))}
            </>
          ) : (
            <Typography variant='caption'>
              {checked ? t('tos_remove_all_tooltip') : t('tos_add_all_tooltip')}
            </Typography>
          )}
        </Stack>
      }
    >
      <Checkbox
        icon={<AddModeratorOutlined />}
        checkedIcon={<VerifiedUserIcon />}
        checked={checked}
        onChange={handleChange}
        style={{ justifySelf: 'right' }}
        sx={{
          ...Buttons.baseStyle.iconButton,
          visibility: !hide ? 'visible' : 'hidden',
          '&.Mui-checked': {
            color: ColorsV2.white,
          },
        }}
      ></Checkbox>
    </Tooltip>
  );
};

export default AddSectionToTOSButton;
